













































































































import Vue from "vue";
import VariableInput, { VariableInputProps} from '@/components/util/VariableInput.vue';
import SelectBoxSimple from "@/components/util/SelectBoxSimple.vue";
import { IconUpdateFlag } from '@/api/dto/UserProfile';
import { getMembers } from "@/api/CorporateMember";
import { createCorporateProject, updateCorporateProject, getProject, deleteProject } from "@/api/Corporation";
import { Member } from "@/api/dto/CorporateMember";
import { Project } from "@/api/dto/Corporation";
import { sortedByDateAsc } from "@/utils/momentUtils";

import { defaultIconUrl } from "@/properties";
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";

interface Data {
  project: Project;
  member: Member[];
  selectMember:  {
    value: number;
    text: string;
    id: string;
    mailAddress: string;
    createdAt: string;
  }[];
  defaultIconUrl: string,
  profileImage: File | null;
  iconUpdateFlag: IconUpdateFlag;
  setKeyword: string;
  owner: { value: number, id: string, name: string, mailAddress: string };
  checkMembers: Member[],
  projectName: Array<VariableInputProps & { key: string }>;
  monthBudget: Array<VariableInputProps & { key: string }>;
  submitModal: boolean;
  deleteProjectConfirmModal: boolean;
  isApiProcessing: boolean;
}
export default Vue.extend({
  name: 'ProjectEdit',
  components: {
    VariableInput,
    SelectBoxSimple,
  },
  data(): Data {
    return {
      project: {} as Project,
      member: [],
      selectMember: [],
      defaultIconUrl,
      profileImage: null,
      iconUpdateFlag: '0',
      setKeyword: '',
      owner: { value: 0, id: "", name: "", mailAddress: ""},
      checkMembers: [],
      projectName: [
        { key: 'projectName', name: 'プロジェクト名', required: true, type: 'text', placeholder: 'プロジェクト名', error: '' },
      ],
      monthBudget: [
        { key: 'monthBudget', name: '月予算', required: false, type: 'text', placeholder: '10,000', error: '' },
      ],
      submitModal: false,
      deleteProjectConfirmModal: false,
      isApiProcessing: false,
    }
  },
  async beforeRouteEnter(to, from, next) {
    let resMember = await getMembers();
    let resProject = {} as Project;
    let selectMember = [] as { value: number; text: string; id: string; mailAddress: string; createdAt: string;}[];
    let owner = { value: 0, id: "", name: "", mailAddress: ""};
    let checkMembers = [] as Member[];

    if (!(to.path == "/corporate/createpj")) {
      resProject = await getProject(to.params.projectId);
      resMember.forEach((member, i) => {
        // selectboxのvalueは1から始まるので添字+1にする
        selectMember.push({ value: i + 1, text: member.nickname, id: member.id, mailAddress: member.mailAddress, createdAt: member.createdAt })
        if (member.id == resProject.managementUserId) {
          owner = { value: i + 1, id: member.id, name: member.nickname, mailAddress: member.mailAddress }
        }
        resProject.projectMember.forEach((userId, j) =>{
          if (member.id == userId) {
            checkMembers.push(member);   
          }
        })
        checkMembers = sortedByDateAsc(checkMembers, (it) => it.createdAt);
      })
      next(vm => {
        (vm.$data as Data).checkMembers = checkMembers;
        (vm.$data as Data).owner = owner;
        (vm.$data as Data).selectMember = selectMember;
        (vm.$data as Data).member = resMember;
        (vm.$data as Data).project = resProject;
      });
    } else {
      resProject.id = '';
      resProject.iconUrl = '';
      resProject.active = false;
      resProject.managementUserId = '';
      resProject.monthBudget = '';
      resProject.projectName = '';
      resProject.corporateId = '';
      resProject.projectMember = [];

      next(vm => {
        (vm.$data as Data).member = resMember;
        (vm.$data as Data).project = resProject;
        (vm.$data as Data).selectMember = selectMember;
      });
    }
  },
  watch: {
    'project.projectName'(projectName: string) {
      this.projectName[0].error = projectName.length <= 30 ? '' : "プロジェクト名は30文字以内で入力してください";
    },
    'project.monthBudget'(monthBudget: string) {
      this.monthBudget[0].error = Number(monthBudget) <= 100000000 ? '' : "月予算は100,000,000円以内で入力してください";
    },
  },
  computed: {
    isDraft(): boolean {
      return this.$route.path == "/corporate/createpj";
    },
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(this.project.projectName != '' 
        && this.project.projectName?.length <= 30 
        && this.project.monthBudget != null 
        && Number(this.project.monthBudget) <= 100000000
        && this.checkMembers.length != 0)
    },
    filteredMember(): Member[] {
      if(this.setKeyword) { 
        return sortedByDateAsc(this.member.filter(value =>  value.nickname?.includes(this.setKeyword)), (it) => it.createdAt);
      } else {
        return sortedByDateAsc(this.member, (it) => it.createdAt);
      }
    },
  },
  methods: {
    changeCheckBox() {
      const beforeOwner = this.owner;

      this.selectMember = [];
      if (this.checkMembers.length == 0) {
        this.owner = { value: 0, id: "", name: "", mailAddress: ""};
        this.selectMember = [];
        return;
      } else {
        this.checkMembers.forEach((member, i) => {
          // valueは1から始まるので+1する
          this.selectMember.push({ value: i + 1, text: member.nickname, id: member.id, mailAddress: member.mailAddress, createdAt: member.createdAt})
        })

        // 管理者のチェックが外された場合、登録日が最も古い管理者を再セットする
        if (this.checkMembers.filter(member => member.id == beforeOwner.id).length === 0) {
          this.owner = { 
            value: this.selectMember.reduce((a,b) =>a.createdAt < b.createdAt?a:b).value, 
            id: this.selectMember.reduce((a,b) =>a.createdAt < b.createdAt?a:b).id,
            name: this.selectMember.reduce((a,b) =>a.createdAt < b.createdAt?a:b).text,
            mailAddress: this.selectMember.reduce((a,b) =>a.createdAt < b.createdAt?a:b).mailAddress 
          }
        } else {
        // 管理者のチェックが外されなかった場合でも、番号がずれるので元のオーナーを再設定する
          const newOwner = this.selectMember.filter(v => v.id == beforeOwner.id)[0]
          this.owner = { 
            value: newOwner.value, 
            id: newOwner.id,
            name: newOwner.text,
            mailAddress: newOwner.mailAddress
          }
        }
      }
      this.selectMember = sortedByDateAsc(this.selectMember, (it) => it.createdAt);
      this.checkMembers = sortedByDateAsc(this.checkMembers, (it) => it.createdAt);
    },
    changeOwner(newOwner: number) {
      this.owner.value = newOwner;
      const member = this.selectMember.filter(v => v.value == newOwner)[0];
      this.owner.id = member.id;
      this.owner.name = member.text;
      this.owner.mailAddress = member.mailAddress;
    },
    uploadFile(e: Event) {
      e.preventDefault();
      if (!(e?.target instanceof HTMLInputElement)) {
        return
      }
      const file = e.target.files?.[0];
      if (!file) {
        return;
      }
      this.profileImage = file;
      this.iconUpdateFlag = '1';
      this.project.iconUrl = URL.createObjectURL(file);
    },
    /**
     * プロジェクト作成
     */
    async createProject() {
      if (this.checkMembers.length == 0) {
        this.$emit("errorToast", "メンバーは最低1名以上選択してください");
        return;
      }
      if (Number(this.project.monthBudget) > 100000000) {
        this.$emit("errorToast", "月予算は100,000,000円以内で入力してください");
        return;
      }

      const checkListMailAddress = []
      for (var i = 0; i < this.checkMembers.length; i++) {
        checkListMailAddress.push(this.checkMembers[i].mailAddress)
      }
      
      try {
        await createCorporateProject({
          icon: this.profileImage,
          projectName: this.project.projectName,
          checkMembers: checkListMailAddress,
          managementUser: this.owner.mailAddress,
          monthBudget: Number(this.project.monthBudget),
        });
      } catch (error) {
        this.$emit('errorToast', 'プロジェクトの作成に失敗しました');
        return;
      }
      this.$emit('toast', 'プロジェクトを作成しました');
      this.$router.push({ name: "Project" });
    },

    /**
     * プロジェクト更新
     */
    async updateProject() {
      if (this.checkMembers.length == 0) {
        this.$emit("errorToast", "メンバーは最低1名以上選択してください");
        return;
      }
      if (this.project.monthBudget == null) {
        this.$emit("errorToast", "月予算は1,000,000円以内で入力してください");
        return;
      }

      const checkListMailAddress = []
      for (var i = 0; i < this.checkMembers.length; i++) {
        checkListMailAddress.push(this.checkMembers[i].mailAddress)
      }

      try {
        await updateCorporateProject({
          id: this.project.id,
          icon: this.profileImage,
          projectName: this.project.projectName,
          checkMembers: checkListMailAddress,
          managementUser: this.owner.mailAddress,
          monthBudget: Number(this.project.monthBudget),
          iconUpdateFlag: this.iconUpdateFlag,
        });
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          this.$emit('errorToast', resError.message);
          return;
        } else {
          this.$emit('errorToast', 'プロジェクトの更新に失敗しました');
          return;
        }
      }
      this.$emit('toast', 'プロジェクトを更新しました');
      this.$router.push({ name: "Project" });
    },

    /**
     * プロジェクト削除
     */
    async deleteProject() {
      try {
        this.isApiProcessing = true;
        await deleteProject(this.project.id)
        this.$emit('toast', 'プロジェクトを削除しました');
        this.$router.push({ name: "Project" });
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          this.$emit('errorToast', resError.message);
          return;
        } else {
          this.$emit('errorToast', 'プロジェクトの削除に失敗しました');
          return;
        }
      } finally {
        this.deleteProjectConfirmModal = false;
        this.isApiProcessing = false;
      }
    }
  },
})
